export const COLORS = {
  Brand: "linear-gradient(135deg, #7CE27E 0%, #07B382 100%)",
  White: "#FFFFFF",
  Hover: "#07B382",
  Disabled: '#364a44'
};
